import {observer} from 'mobx-react-lite';
import {KeywordsMiniTable} from './keywordsMiniTable';
// import {DetailedOverviewDrawer} from './DetailedOverviewDrawer';
import React from 'react';
import styled from 'styled-components';
import {useStore} from '@/store/root-store';
import {formatNumber} from '@/utils/number';
import {useRouter} from 'next/router';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {Tooltip} from 'antd';

import {SkeletonHorizontalLoaderGray} from '@/components/common-components';
import {getDomain, getSingleUrlParam, isPublicKeywordResearcherV2} from '@/utils/url';
import {faSparkles} from '@fortawesome/pro-duotone-svg-icons';
import {Button} from '@/components/common-components/v2';
import Link from 'next/link';
import {linkgraphDomains} from '@/utils/router';

interface Props {
  fromDrawer?: boolean;
  termsMatchQuestionsTableData?: any;
  termsMatchTableData?:any;
}

export const SuggestedKeywordsTables: React.FC<Props> = observer(({fromDrawer=false, termsMatchQuestionsTableData, termsMatchTableData}) => {
  const {
    keywordResearcherV2: {
      keywordDetails: {
        getKeywordDetailsData,
        getKeywordDetailList,
        loadingKeywordMainDetails,
        loadingTermsMatchDetails,
        loadingTermsMatchQuestionsDetails,
      },
    }} = useStore('');
  const {settings: {customer: {setAuthModal}}} = useStore('');
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);


  const {contentOptimizer: {currentPage}} = useStore('');
  const router = useRouter();
  const listId = fromDrawer ? getKeywordDetailList?.id : router.query?.keyword?.length ? router.query.keyword[0] : '';
  const keyword = fromDrawer ? getKeywordDetailsData?.keyword : router.query?.keyword?.length ? router.query.keyword[1] : '';
  const publicShareHash = fromDrawer ? getKeywordDetailList?.publicShareHash : getSingleUrlParam('public_hash');
  const countryCode = fromDrawer ? getKeywordDetailsData?.countryCode : getSingleUrlParam('countryCode') ?? getKeywordDetailsData?.countryCode;
  const countryName = getSingleUrlParam('countryName') ?? getKeywordDetailsData?.location;
  const locationId = fromDrawer ? getKeywordDetailsData?.locationId : getSingleUrlParam('locationId') ?? getKeywordDetailsData?.locationId;

  const getLocation = `locationId=${locationId || ''}&countryCode=${countryCode || ''}&countryName=${countryName || ''}`;

  const linkWithQuestion = isPublicKeywordResearcherV2() ? `/research/keyword-magic-tool-public/${listId}/${keyword}?public_hash=${publicShareHash}&${getLocation}&table=questions` :
    `/research/keyword-magic-tool/${listId}/${keyword}?${getLocation}&table=questions`;
  const linkWithRelatedKw = isPublicKeywordResearcherV2() ? `/research/keyword-magic-tool-public/${listId}/${keyword}?public_hash=${publicShareHash}&${getLocation}&table=related_keywords` :
    `/research/keyword-magic-tool/${listId}/${keyword}?${getLocation}&table=related_keywords`;
  const linkSimple = isPublicKeywordResearcherV2() ? `/research/keyword-magic-tool-public/${listId}/${keyword}?public_hash=${publicShareHash}&${getLocation}&table=keyword_variation` :
    `/research/keyword-magic-tool/${listId}/${keyword}?${getLocation}&table=keyword_variation`;

  return (
    <Container>
      {(isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? ' ' : isPublicKeywordResearcherV2() && <KeywordBanner>
        <FontAwesomeIcon icon={faSparkles} style={{color: '#2D6CCA', marginRight: 16, fontSize: 20}}/>
        Upgrade to see millions of keyword variations and high search volume questions.<Button color='blue' style={{height: '32px'}} onClick={() => setAuthModal(true, false)}>Explore keywords</Button></KeywordBanner>}

      <InnerContainer> <TableContainer isCaDrawer={currentPage?.isDrawerFromCa || !getKeywordDetailsData?.relatedKeywordsFirstArr?.length}>

        <Info>
          <Heading>Keyword Variations&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            Variations of the keyword that still represent the same search intent
          </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip></Heading>
          <ValuesWrapper>
            {loadingTermsMatchDetails ? <SkeletonHorizontalLoaderGray lightLoader skeletonHeight={'10px'} height={'29px'} width={'180px'}/> :
              termsMatchTableData?.results?.length ?

                <>
                  <Link legacyBehavior href={linkSimple} passHref>
                    <a target={fromDrawer ? '_blank' : ''}>
                      <MainValue>{termsMatchTableData?.count ? String(formatNumber(termsMatchTableData?.count, 1))?.replace('.0', '') : '0'}</MainValue>
                    </a>
                  </Link>
                  <TotalVolume>Total volume: {termsMatchTableData?.results?.length ? String(formatNumber(termsMatchTableData?.results?.reduce((a, b) => a + b?.sv, 0), 1))?.replace('.0', '') : ''}</TotalVolume>
                </> : ''}
          </ValuesWrapper>
        </Info>
        <KeywordsMiniTable fromDrawer={fromDrawer} redirectLink={linkSimple} tableData={termsMatchTableData?.results?.slice(0, 5)} loadingKeywordDetails={loadingTermsMatchDetails} totalValue={String(formatNumber(termsMatchTableData?.count, 1))?.replace('.0', '')} />
      </TableContainer>
      {currentPage?.isDrawerFromCa || !getKeywordDetailsData?.relatedKeywordsFirstArr?.length ? '' : <TableContainer>
        <Info>
          <Heading>RELATED KEYWORDS&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            Keywords with topical releance to the primary keyword.
          </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip></Heading>
          <ValuesWrapper>
            {loadingKeywordMainDetails ? <SkeletonHorizontalLoaderGray lightLoader skeletonHeight={'10px'} height={'29px'} width={'180px'}/> :
              getKeywordDetailsData?.relatedKeywordsFirstArr?.length ?
                <>
                  <Link legacyBehavior href={linkWithRelatedKw} passHref>
                    <a target={fromDrawer ? '_blank' : ''}>
                      <MainValue>{getKeywordDetailsData?.relatedKeywordsFirstArr?.length ? String(formatNumber(getKeywordDetailsData?.relatedKeywordsFirstArr?.length, 1))?.replace('.0', '') : '0'}</MainValue>
                    </a>
                  </Link>
                  <TotalVolume>Total volume: {getKeywordDetailsData?.relatedKeywordsFirstArr?.length ? formatNumber(getKeywordDetailsData?.relatedKeywordsFirstArr?.reduce((a, b) => a + b?.sv, 0)) : ''}</TotalVolume>
                </> :''}
          </ValuesWrapper>
        </Info>
        <KeywordsMiniTable fromDrawer={fromDrawer} redirectLink={linkWithRelatedKw} tableData={getKeywordDetailsData?.relatedKeywordsFirstArr?.slice(0, 5)} loadingKeywordDetails={loadingKeywordMainDetails} totalValue={String(formatNumber(getKeywordDetailsData?.relatedKeywordsFirstArr?.length, 1))?.replace('.0', '')}/>
      </TableContainer>}
      <TableContainer isCaDrawer={currentPage?.isDrawerFromCa || !getKeywordDetailsData?.relatedKeywordsFirstArr?.length}>
        <Info>
          <Heading>QUESTIONS&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            Questions users are asking in relationship to this keyword.
          </TooltipDescriptionWrapper>} placement={'bottom'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip></Heading>
          <ValuesWrapper>
            {loadingTermsMatchQuestionsDetails ? <SkeletonHorizontalLoaderGray lightLoader skeletonHeight={'10px'} height={'29px'} width={'180px'}/> :
              termsMatchQuestionsTableData?.results?.length?
                <>
                  <Link legacyBehavior href={linkWithQuestion} passHref>
                    <a target={fromDrawer ? '_blank' : ''}>
                      <MainValue>{termsMatchQuestionsTableData?.count ? String(formatNumber(termsMatchQuestionsTableData?.count, 1))?.replace('.0', '') : '0'}</MainValue>
                    </a>
                  </Link>
                  <TotalVolume>Total volume: {termsMatchQuestionsTableData?.results?.length ? formatNumber(termsMatchQuestionsTableData?.results?.reduce((a, b) => a + b?.sv, 0)) : ''}</TotalVolume>
                </> :''}
          </ValuesWrapper>
        </Info>
        <KeywordsMiniTable fromDrawer={fromDrawer} redirectLink={linkWithQuestion} tableData={termsMatchQuestionsTableData?.results?.slice(0, 5)} loadingKeywordDetails={loadingTermsMatchQuestionsDetails} totalValue={String(formatNumber(termsMatchQuestionsTableData?.count, 1))?.replace('.0', '')}/>
      </TableContainer></InnerContainer>
      {/* <DetailedOverviewDrawer countryCode={country} /> */}
    </Container>
  );
});

const Container = styled.div`
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  padding: 28px 20px 20px 18px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const TableContainer = styled.div<{isCaDrawer?: boolean}>`
  width: ${p => p.isCaDrawer ? '48%' : '32%'};
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

// const BillionKeyword = styled.span`
// color:#7F4EAD;
// font-family: Inter;
// font-size: 14px;
// font-weight: 700;
// line-height: 17px;
// letter-spacing: 0em;
// text-align: left;
// `;

const KeywordBanner = styled.div`
  width: 100%;
  height:50px;
  background:#2D6CCA26;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  color:#121212 !important;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 35px;

`;
const InnerContainer = styled.div`
  display:flex;
  justify-content:space-between;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const Info = styled.div`

`;

const Heading = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: #121212;
`;

const MainValue = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #2D6CCA;
  cursor: pointer;
`;

const ValuesWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const TotalVolume = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #4E5156;
  margin-left: 8px;
`;
const TooltipDescriptionWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #121212;
  padding: 5px;
`;
